import React from "react";
import {Route} from "react-router-dom";
import LayersListWrapper from "../../containers/map/tools/LayersList/LayersListWrapper";
import LayersTimeSelectors from "../../components/map/LayersTimeSelectors";
import BreadcrumbedComponent from "../../components/BreadcrumbedComponent/BreadcrumbedComponent";
import PopulationEventsList from "./Manager/PopulationEventsList";
import PopulationEventEdit from "./Manager/PopulationEventEdit";
import NetworkEventsList from "./Manager/NetworkEventsList";
import TransitEventsList from "./Manager/TransitEventsList";
import NetworkEventEdit from "./Manager/NetworkEventEdit";
import TransitEventEdit from "./Manager/TransitEventEdit";
import LazyLoadingWrapper from "../../components/LazyLoadingWrapper/LazyLoadingWrapper";
import EvEventsList from "./Manager/EvEventsList";
import EvEventEdit from "./Manager/EvEventEdit";
import NavigateWithSearch from "../../components/NavigateWithSearch/NavigateWithSearch";
import EmissionsEventsList from "./Manager/EmissionEventsList";
import EmissionEventEdit from "./Manager/EmissionEventEdit";


const ScenarioPresetsModePage = React.lazy(() => import('./ScenarioPresetsModePage'));

export const useScenarioPresetsRoutes = () => {
    return (
        <Route path="scenario" element={<LazyLoadingWrapper element={<ScenarioPresetsModePage/>}/>}>
            <Route index element={<NavigateWithSearch to="population" replace/>}/>
            <Route
                element={<BreadcrumbedComponent/>}
                handle={{crumb: (data: any) => ({pathnamePostFix: 'population', name: 'Events', ...data})}}
            >
                <Route path="population">
                    <Route index element={<PopulationEventsList/>}/>
                    <Route path="new" element={<PopulationEventEdit/>}/>
                    <Route
                        path=":populationEventId/edit"
                        element={<PopulationEventEdit/>}
                        loader={({params}) => params}
                        handle={{crumb: ({populationEventId}) => ({id: populationEventId})}}
                    />
                </Route>
            </Route>
            <Route
                element={<BreadcrumbedComponent/>}
                handle={{crumb: (data: any) => ({pathnamePostFix: 'network', name: 'Events', ...data})}}
            >
                <Route path="network" element={<NetworkEventsList/>}/>
                <Route
                    path="network/new"
                    element={<NetworkEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({networkEventId}) => ({id: networkEventId})}}
                />
                <Route
                    path="network/:networkEventId/edit"
                    element={<NetworkEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({networkEventId}) => ({id: networkEventId})}}
                />
            </Route>
            <Route
                element={<BreadcrumbedComponent/>}
                handle={{crumb: (data: any) => ({pathnamePostFix: 'transit', name: 'Events', ...data})}}
            >
                <Route path="transit" element={<TransitEventsList/>}/>
                <Route
                    path="transit/new"
                    element={<TransitEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({networkEventId}) => ({id: networkEventId})}}
                />
                <Route
                    path="transit/:transitEventId/edit"
                    element={<TransitEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({transitEventId}) => ({id: transitEventId})}}
                />
            </Route>
            <Route
                element={<BreadcrumbedComponent/>}
                handle={{crumb: (data: any) => ({pathnamePostFix: 'ev', name: 'Events', ...data})}}
            >
                <Route path="ev" element={<EvEventsList/>}/>
                <Route
                    path="ev/new"
                    element={<EvEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({evEventId}) => ({id: evEventId})}}
                />
                <Route
                    path="ev/:evEventId/edit"
                    element={<EvEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({evEventId}) => ({id: evEventId})}}
                />
            </Route>
            <Route
                element={<BreadcrumbedComponent/>}
                handle={{crumb: (data: any) => ({pathnamePostFix: 'emission', name: 'Events', ...data})}}
            >
                <Route path="emission" element={<EmissionsEventsList/>}/>
                <Route
                    path="emission/new"
                    element={<EmissionEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({emissionEventId}) => ({id: emissionEventId})}}
                />
                <Route
                    path="emission/:emissionEventId/edit"
                    element={<EmissionEventEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({emissionEventId}) => ({id: emissionEventId})}}
                />
            </Route>
            <Route
                path='layers'
                element={
                    <LayersListWrapper>
                        <LayersTimeSelectors/>
                    </LayersListWrapper>
                }
            />
        </Route>
    )
}